import {
  DashboardComponentPropsBase,
  IComponentTimed,
} from "components/pages/dashboard/components/interfaces";
import { ReportOptions } from "models/component-print-models";
import { Align } from "types/types";
import { LagLeadLoadingConfig } from "../charts/interfaces";
import { IDateRange } from "../product-template-table/utils/interfaces";

export interface SparkLineProps
  extends IComponentTimed,
    DashboardComponentPropsBase<ReportOptions>,
    AdvancedProps,
    ValueLabelWidthParameters,
    IDateRange {
  displayCharts?: boolean;
  chartIndex?: number;
  valueScaling?: number;
  decimalPlaces?: number;
  labelFontSize?: string;
  sparkLineWidth?: number;
  dataset: string | null;
  lineColor?: string;
  lineWidth?: number;
  count?: number;
  unit?: string;
  overlayLabel?: boolean;
  vertical?: Align;
  horizontal?: Align;
  updateFrequency?: number;
  advanced?: boolean;
  height?: number;
  maxAge?: number;
  isMultipleCharts?: boolean;
  generalProperties?: GeneralProperties;
  multipleCharts: SparkLineProps[];
  useLoadConf?: boolean;
  loadConf?: LagLeadLoadingConfig;
  maxYAxis?: number;
  minYAxis?: number;
}

export interface GeneralProperties {
  valuePosition?: ValuePosition;
  hideValues?: boolean;
  customValueWidth?: number;
  valueAlign?: Align;
}

export interface AdvancedProps {
  data: Datapoint[];
  baseline?: LineConfig;
  minLine?: LineConfig;
  maxLine?: LineConfig;
  count?: number;
  updateFrequency?: number;
  showYAxis?: boolean;
  referenceTime?: string;
}

export type Datapoint = { y: number; x: Date };

export type Usages = "none" | "dataset" | "constant";

export enum ValuePosition {
  TOP = "top",
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
}

export interface LineConfig {
  usage?: Usages;
  constant?: number;
  dataset?: string;
  width?: number;
  color?: string;
  fillAboveColor?: string;
  fillBelowColor?: string;
}

interface ValueLabelWidthParameters {
  currentBiggestValueWidth?: number;
  setCurrentBiggestValueWidth?: (currentBiggestValueWidth: number, chartIndex: number) => void;
}

export interface ISparkLineHandlerProps extends ValueLabelWidthParameters {
  title: string;
  displayCharts?: boolean;
  chartIndex?: number;
  dataset: string;
  dataArray: number[];
  lineColor?: string;
  lineWidth?: number;
  lastValueTime: Date | null;
  sparklineWidth?: number;
  labelFontSize?: string;
  decimalPlaces?: number;
  unit?: string;
  height?: number;
  overlayLabel?: boolean;
  vertical?: Align;
  horizontal?: Align;
  maxAge?: number;
  advanced?: boolean;
  advancedProps?: AdvancedProps;
  generalProperties?: GeneralProperties;
  isMultipleCharts?: boolean;
  stringValueMapper?: number;
  minYAxis?: number;
  maxYAxis?: number;
}

export type ValueLabel = {
  disconnected: boolean;
  value?: number;
  decimalPlaces: number;
  content: string | React.ReactNode;
  bgColor: string;
  textColor?: string;
};
